import React, {Component} from 'react';
import '../../containers/newsActivity/newsActivityIndex.css';
import '../../containers/newsActivity/newActivityBaseInfostyle.css';
import "./topicSelectionList.css";
import {Form, Select, message, Popover, Tag, Input, DatePicker, Button, Table, Modal, AutoComplete, Pagination} from 'antd';
import prev from './prev.png';
import {
    addTopicSelection, assignedWriting, deleteTopicSelectionById,
    editStatusTopicSelection,
    editTopicSelection,
    getPmsUser, getTopicSelectionById,
    getTopicSelectionList
} from "../../actions/topicSelection";
import {connect} from "react-redux";
import {Scrollbars} from "react-custom-scrollbars";
import {ATTCHMENT_TYPE, AUDIO_TYPE, FILE_TYPE, HEADER_HEIGHT, PIC_TYPE, VIDEO_TYPE} from "../../constants";
import moment from "moment";
import UploadWall from "../upload/UploadWall";
import ChunkUpload from "../upload/ChunkUpload";
import {getAttachmentFiles} from "../../actions/newsActivityAction";
import {checkFileStatus} from "../../actions/upload";
import {applicationName, permissionCheck, uuid} from "../../utils";
import {EditableTagGroup} from "../editableTagGroup";
import {haveEditAuthRoleCode} from "../../containers/newsActivity/NewsActivityIndex";
import TabModal from "../TabModal";
import TopicSelectionBaseInfo from "./TopicSelectionBaseInfo";
import Manuscript from "../major-projects/projectInfo/manuscript";
import NewsActivityComplete from '../../containers/newsActivity/NewsActivityComplete'
import {shrinNavigateStauts, updataNavigateData, updateNavigateLevel2Data} from "../../actions";
import eventProxy from "../../utils/eventProxy";

const {Option} = Select;
const {RangePicker } = DatePicker;
const { Search } = Input;
const {TextArea} = Input;
const { confirm } = Modal;

export const STATUTS_MAP = {
    type_0: {name:"全部",className:"unget_status",value:0},
    type_1: {name:"草稿",className:"unget_status",value:1},
    type_2: {name:"已提交",className:"recieve_status",value:2},
    type_3: {name:"已撤回",className:"unget_status",value:3},
    type_4: {name:"留用",className:"publish_status",value:4},
    type_5: {name:"已弃用",className:"publish_status",value:5},
    type_6: {name:"已采用",className:"publish_status",value:6},
    type_7: {name:"转为任务",className:"recieve_status",value:7},
    type_8: {name:"已指派",className:"recieve_status",value:8},
};

class TopicSelectionList extends Component {


    columns = [
        {
            key:'1',
            title: 'type',
            dataIndex: 'type',
            width: '4%',
            render:(value, row, index)=>{
                return <div>
                <img src={prev} width={'53px'}/>
                </div>
            }
        },
        {
            key:'2',
            title: 'title',
            dataIndex: 'title',
            width: '36%',
            ellipsis: true,
            render:(value, row)=>{
                return <div style={{cursor:"pointer",width:"100%"}} onClick={()=>{
                    this.viewTopicSelection(row);
                }}>{this.renderTitle(row)}</div>
            }
        },
        {
            key:'3',
            title: '提交时间',
            dataIndex: 'tsCreateTime',
            width: '15%',
            render:(value, row, index)=>{
                return <div style={{color: '#8792b3',fontSize:'15px',fontWeight:"bold"}}>
                <img width={'18px'} src={'images/newsactivity/newsactivity_time.png'}/>
                <span style={{marginLeft:'10px'}}>{value?value:"未提交"}</span></div>;
            }
        },
        {
            key:'4',
            title: '状态',
            dataIndex: 'tsStatus',
            width: '10%',
            render:(value, row, index)=>{
                return this.formateStatus(value);
            }
        },
        {
            key:'5',
            title: '操作',
            width:'15%',
            render: (value, row, index) => {
                let btns = this.getBtns(this.props.currentUser, haveEditAuthRoleCode, row);
                return <div style={{color:'#576184',fontFamily: 'MicrosoftYaHei-Bold',
                    fontSize: '15px',fontWeight: 'bold'}}>
                    {btns.map(({name,click,type},index)=>{
                        if(type && (type.name === "popover")){
                            return <Popover placement="top" key={index} title={undefined} content={type.content} trigger="click">
                                <a className={'operation_button'}>{name}</a>
                            </Popover>
                        }else{
                            return <a className={'operation_button'} key={index} onClick={click}>{name}</a>;
                        }
                    })}
                </div>
            },
        },
    ];

    getBtns = (currentUser, haveEditAuthRoleCode, row)=>{
        let btns = [];
        let {tsStatus, tsCreateBy, tsAppointee} = row;
        // let isManager = currentUser && currentUser.roleCodes && (currentUser.roleCodes.indexOf(haveEditAuthRoleCode) !== -1);//是否有高级管理的权限
        let isManager=permissionCheck("pms:topicSelect:chooseUsing")
        let isMy = currentUser && tsCreateBy && (tsCreateBy[0] === currentUser.account);//创建人是自己的
        let isAssign = currentUser && tsAppointee && (tsAppointee.indexOf(currentUser.account) !== -1);//是否分派给自己的

        switch (parseInt(tsStatus)) {
            case 1:
            case 3: isMy && (btns = [...btns, {name:"修改", click:()=>{this.updateData(row)}}, {name:"删除", click:()=>{this.deleteData(row)}}]); break;
            case 2: isManager&&(btns = [...btns, {name:"采用", click:()=>{this.useData(row)}}, {name:"弃用", click:()=>{this.qiyongData(row)}}, {name:"留用", click:()=>{this.liuyongData(row)}}]);
                    isMy && (btns = [...btns, {name:"撤回", click:()=>{this.backData(row)}}]);
                    break;
            case 4: isManager&&(btns = [...btns, {name:"采用", click:()=>{this.useData(row)}}, {name:"弃用", click:()=>{this.qiyongData(row)}}]); break;
            case 5: isManager && (btns = [...btns, {name:"删除", click:()=>{this.deleteData(row)}}]); break;
            case 6: isManager && (btns = [...btns, {name:"转为任务", click:()=>{this.convertActivity(row)}}, {name:"指派写作", click:()=>{this.assignWrite(row)}}]); break;
            case 7: isManager && (btns = [...btns, {name:"查看任务", click:()=>{this.viewActivity(row)}}]); break;
            case 8: isManager && btns.push({name:"查看稿件", click:()=>{this.viewStoryList(row)}});
                    isAssign && btns.push({name:"写稿", click:()=>{this.writeStory(row)}});
                    (isAssign || isManager) && btns.push({name:"查看备注",click:()=>{this.viewRemarks(row)},type:{name:"popover",content:row.tsRemark}});
                    break;
        }
        return btns;
    };

    defaultState = {
        topicSelection:{},
        data:[],
        count:0,
        size:10,
        start:1,
        queryStr:"",
        tsStartDate:undefined,
        tsEndDate:undefined,
        tsListStatus:0,//(0全部选题,1我的选题)
        tsStatus:0,//0代表全部状态(选题状态1草稿,2提交,3撤回,4留用,5已弃用,6已采用,7转为活动,8已指派)
        tsDirection:0,//(方位0选题列表,1关联选题列表)
        topicSelectionListFormModalVisible:false,
        topicSelectionListFormKey:uuid(),
        viewTopicSelectionVisible:false,
        assignModalVisible:false
    };

    state={
        ...this.defaultState,
        step:1,
    };

    pmsUser = [];//这里避免其他地方再次进行修改，直接就放在了属性里面。
    componentWillMount() {
        getPmsUser().then(dto=>{
            this.pmsUser = dto.data;
            this.setState({})
        });
        window.loading.show();
        //我的桌面 我的选题 只展示我的选题
       if(this.props.hideHead){
           let tsListStatus = 1;
           this.setState({
               tsListStatus
           });
           this.loadData({
               ...this.state,tsListStatus
           }, ()=>{
               window.loading.hide();
           });
       }else{
           this.loadData(this.state, ()=>{
               window.loading.hide();
           });
       }
    }
    componentWillUnmount = () => {
        // 清除监听
    };


    loadData({start,size,queryStr,tsListStatus,tsStatus,tsStartDate,tsEndDate,tsDirection},callBack){
        getTopicSelectionList({start,size,queryStr,tsListStatus,tsStatus,tsStartDate,tsEndDate,tsDirection}).then(dto=>{
            if(callBack){
                callBack();
            }
            this.setState({
                ...dto,
                start,size,queryStr,tsListStatus,tsStatus,tsStartDate,tsEndDate,tsDirection
            })
        })
    }

    /**
     * 格式化，状态。
     * @param value
     */
    formateStatus(value){
        if(STATUTS_MAP["type_"+value]){
            return <div className={STATUTS_MAP["type_"+value].className}>{STATUTS_MAP["type_"+value].name}</div>
        }
        return <div></div>
    }

    viewRemarks = (topicSelection)=>{
        if(topicSelection.id){
            getTopicSelectionById(topicSelection.id).then(dto=>{
                message.info(dto.data.tsRemark);
            });
        }
    };

    writeStory(topicSelection){
        let interviewId = topicSelection.topicSelection || 0;
        let url = "/cm-sites/pms/addContribute/addContributeNews.html?interviewId=" +interviewId+ "&eiditStoryId=0&attribute=original&topicSelectionId="+topicSelection.id+"&actButtonId=30&isShowMainColumnSetBtn=false&passMediaCodes=";
        let that = this;
        window.openFull(url, "稿件编辑", function () {
        }, {
            shade: 0.5,
            area: [parseInt(window.document.body.clientWidth * 0.9) + 'px', parseInt(window.document.body.clientHeight * 0.9) + 'px']
        }, function () {

        let    defaultState = {
                topicSelection:{},
                data:[],
                count:0,
                size:10,
                start:1,
                queryStr:"",
                tsStartDate:undefined,
                tsEndDate:undefined,
                tsListStatus:that.state.tsListStatus,//(0全部选题,1我的选题)
                tsStatus:0,//0代表全部状态(选题状态1草稿,2提交,3撤回,4留用,5已弃用,6已采用,7转为活动,8已指派)
                tsDirection:0,//(方位0选题列表,1关联选题列表)
                topicSelectionListFormModalVisible:false,
                topicSelectionListFormKey:uuid(),
                viewTopicSelectionVisible:false,
                assignModalVisible:false
            };

            that.loadData(defaultState);
        })
    }

    viewActivity(topicSelection){
        window.location.hash = `/newsActivityIndex/newsActivityIndex`;
        setTimeout(() => {
            eventProxy.trigger('view',topicSelection.id)
        },0);
    }

    viewTopicSelectionActiveIndex = 0;
    viewStoryList(topicSelection){
        if(topicSelection.id){
            getTopicSelectionById(topicSelection.id).then(dto=>{
                this.viewTopicSelectionActiveIndex = 1;
                this.setState({
                    topicSelection:dto.data,
                    viewTopicSelectionVisible : true,
                })
            });
        }
    }

    assignWrite(topicSelection){
        this.selectAssignAccount = [];
        this.tsRemark = "";
        this.setState({
            assignModalVisible: true,
            topicSelection:topicSelection
        })
    }

    selectAssignAccount = [];//选择的指派人
    tsRemark = "";//指派的时候写的回复
    tagGroupChange(tags){
        let pmsUser = this.pmsUser;
        let tsAppointee = [];
        for(let i = 0 ; tags && i < tags.length; i++){
            let tagName = tags[i];
            for(let j = 0 ; pmsUser && j < pmsUser.length; j++){
                let user = pmsUser[j];
                if(user.name === tagName){
                    let isAdd = true;//已经添加过的账号就不添加了
                    for(let k = 0; tsAppointee && k < tsAppointee.length; k++){
                        if(tsAppointee[k] === user.account){
                            isAdd = false;
                            break;
                        }
                    }
                    if(isAdd){
                        tsAppointee.push(user.account);
                    }
                    break;
                }
            }
        }
        this.selectAssignAccount = tsAppointee;
    }

    convertActivity(topicSelection){
        let url=`/newsActivityIndex/newsActivityIndex`
        let {stopFind, sons, name} = this.findUrlData(url);
        if (stopFind) {
            this.props.shrinNavigateStauts();
            this.props.updateNavigateLevel2Data(name, sons);
            this.props.navigateData.forEach(item => {
                if (item.name === name) {
                    item.check = true;
                    item.status = "down"
                } else {
                    item.check = false;
                    item.status = "up"
                }
            });
            this.props.updataNavigateData(this.props.navigateData);
            window.location.hash = url;
            setTimeout(() => {
                eventProxy.trigger('add',topicSelection.id)
            },0);
            return;
        }
    }

    //格式化url
    findUrlData = (url) => {
        let sons;
        let name;
        let stopFind = false;
        let find = (data, level, levelOneBrothers, levelOneName) => {
            if (stopFind)
                return;
            if ((!data.sons || data.sons.length === 0) && (!data.float_ || data.float_.length === 0)) {
                if (data.path === url) {
                    sons = levelOneBrothers;
                    name = levelOneName;
                    stopFind = true;
                }
                return;
            }
            let tempSons = data.float_;
            if (!tempSons || tempSons.length === 0) {
                tempSons = data.sons;
            }
            if (stopFind)
                return;
            tempSons && tempSons.map(item => {
                if (stopFind)
                    return;
                let tempItemSons = item.float_;
                if (!tempItemSons || tempItemSons.length === 0) {
                    tempItemSons = item.sons;
                }
                if (level == 0) {//取第一级的信息
                    find(item, level + 1, tempItemSons, item.name);
                } else {
                    find(item, level + 1, levelOneBrothers, levelOneName);
                }
            })
        };
        find({sons: this.props.navigateData}, 0, null, null);
        return {stopFind, sons, name};
    };
    backData(topicSelection){
        confirm({
            //className:'delete_dialog',
            title: '提示',
            content: '确定撤回此选题？',
            okText: '确定',
            // okType: 'danger',
            cancelText: '取消',
            onOk:()=>{
                this.editStatus(topicSelection.id, 3);
            },
            onCancel() {

            },
        });
    }

    editStatus(id, tsStatus){
        window.loading.show();
        editStatusTopicSelection(id, tsStatus).then(dto=>{
            window.loading.hide();
            if(dto.status === 200){
                let {topicSelectionListFormModalVisible,viewTopicSelectionVisible,assignModalVisible} = this.defaultState;
                this.loadData({...this.state,topicSelectionListFormModalVisible,viewTopicSelectionVisible,assignModalVisible});

                if(this.state.viewTopicSelectionVisible){//如果查看的那个框子打开了就重新加载
                    this.viewTopicSelection(this.state.topicSelection);
                }
                this.setState({
                    topicSelectionListFormModalVisible:false,
                    topicSelectionListFormKey:uuid()
                });
            }else{
                message.error(dto.msg);
            }
        })
    }

    useData(topicSelection){
        this.editStatus(topicSelection.id, 6);
    }

    qiyongData(topicSelection){
        confirm({
            title: '提示',
            content: '确定弃用此选题？',
            okText: '确定',
            cancelText: '取消',
            onOk:()=>{
                this.editStatus(topicSelection.id, 5);
            },
            onCancel() {

            },
        });
    }

    liuyongData(topicSelection){
        this.editStatus(topicSelection.id, 4);
    }

    updateData(topicSelection){
        this.setState({
            topicSelectionListFormModalVisible:true,
            viewTopicSelectionVisible:false,
            topicSelectionListFormKey:uuid(),
            topicSelection,
            step: 1,
        })
    }

    deleteData(topicSelection){
        confirm({
            title: '提示',
            content: '确定删除此选题？',
            okText: '确定',
            cancelText: '取消',
            onOk:()=>{
                window.loading.show();
                deleteTopicSelectionById(topicSelection.id).then(dto=>{
                    window.loading.hide();
                    if(dto.status === 200){
                        this.loadData(this.defaultState);
                        this.setState({
                            topicSelectionListFormModalVisible:false,
                            topicSelectionListFormKey:uuid(),
                            viewTopicSelectionVisible:false
                        });
                    }else{
                        message.error(dto.msg);
                    }
                });
            },
            onCancel() {

            },
        });
    }

    viewTopicSelection(topicSelection){
        if(topicSelection.id){
            getTopicSelectionById(topicSelection.id).then(dto=>{
                this.viewTopicSelectionActiveIndex = 0;
                this.setState({
                    topicSelection:dto.data,
                    viewTopicSelectionVisible : true
                })
            });
        }
    }
    /**
     * 任务页面，标题列的渲染。
     * @param record
     */
    renderTitle(record){
        return <div className={"row_title"} style={{width:"100%"}}>
            <div className={"record_title"} style={{width:"100%", overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'}}>{record.tsName}</div>
            <div className={"record_content"} style={{width:"100%", overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'}}>{record.tsContent}</div>
        </div>
    }

    showAddModal(){
        this.viewTopicSelectionActiveIndex = 0;
        this.setState({
            topicSelection:{
                tsCreateBy: this.props.currentUser?[this.props.currentUser.account]:[]
            },
            topicSelectionListFormModalVisible:true,
            topicSelectionListFormKey:uuid(),
            step: 1
        })
    }

    save(tsStatus){
        let errorsInfo=[];
        this.topicSelectionListForm.props.form.validateFields((errors,values)=>{
            errorsInfo=errors;
        });

        if(errorsInfo){
            for(let i in errorsInfo){
                message.error(errorsInfo[i].errors[0].message,1);
                return false;
            }
        }

        let tsFileIds = [];
        for(let i = 0 ; this.topicSelectionListForm.state.fileList && i < this.topicSelectionListForm.state.fileList.length; i++){
            let file = this.topicSelectionListForm.state.fileList[i];
            if(file.resourceId){
                tsFileIds.push(file.resourceId);
            }
        }

        let topicSelection = this.topicSelectionListForm.props.form.getFieldsValue();
        topicSelection.tsFileIds = tsFileIds;
        topicSelection.id = this.state.topicSelection.id;
        topicSelection.tsCreateBy = this.state.topicSelection.tsCreateBy;
        if(tsStatus){
            topicSelection.tsStatus = tsStatus;
        }else if(this.state.topicSelection.tsStatus){
            topicSelection.tsStatus = this.state.topicSelection.tsStatus;
        }
        window.loading.show();
        if(this.state.topicSelection.id > 0){
            editTopicSelection(topicSelection).then(dto=>{
                window.loading.hide();
                //message.success("修改成功");
                this.loadData(this.defaultState);
                this.setState({
                    //topicSelectionListFormModalVisible:false,
                    topicSelectionListFormKey:uuid(),
                    step: 2,
                    topicSelection,
                });
            });
        }else{
            addTopicSelection(topicSelection).then(dto=>{
                window.loading.hide();
                //message.success("添加成功");
                this.loadData(this.defaultState);
                this.setState({
                   // topicSelectionListFormModalVisible:false,
                    topicSelectionListFormKey:uuid(),
                    step: 2,
                    topicSelection,
                });
            })
        }
    }

    render() {
        let newSecondSelectColor = this.props.sysConfig && this.props.sysConfig.getValueByKey ? this.props.sysConfig.getValueByKey("newSecondSelectColor", '#0050B3') : '#0050B3';
        return (<div style={{padding:'20px'}}>

                    {this.props.hideHead?null:<div>
                        <div className={"select_title"} style={{color:newSecondSelectColor}}>选题管理</div>
                        <div className={"newActiviti_status"}>
                            <Form labelCol={{span: 5}} wrapperCol={{span: 12}}>
                                <div className={'form_item'}>
                                    <div className={"topic-selection-switch-block"}>
                                        <div className={this.state.tsListStatus===0?"topic-selection-switch-checked":""}
                                             style={{color:this.state.tsListStatus===0?"#fefeff":newSecondSelectColor, float:"left",width: "93px", backgroundColor:this.state.tsListStatus===0?newSecondSelectColor:"",borderColor:this.state.tsListStatus===0?newSecondSelectColor:""}} onClick={()=>{
                                            let tsListStatus = 0;
                                            this.setState({
                                                tsListStatus
                                            });
                                            this.loadData({
                                                ...this.state,tsListStatus
                                            });
                                        }}>全部选题</div>
                                        <div className={this.state.tsListStatus===1?"topic-selection-switch-checked":""}
                                             style={{color:this.state.tsListStatus===0?newSecondSelectColor:"#fefeff",float:"left",width: "93px",backgroundColor:this.state.tsListStatus===1?newSecondSelectColor:"",borderColor:this.state.tsListStatus===1?newSecondSelectColor:""}} onClick={()=>{
                                            let tsListStatus = 1;
                                            this.setState({
                                                tsListStatus
                                            });
                                            this.loadData({
                                                ...this.state,tsListStatus,start:1,size:10
                                            });
                                        }}>我的选题</div>
                                    </div>
                                    <div style={{clear:"both"}}></div>
                                </div>
                                <div className={'form_item'}>
                                    <Select
                                        defaultValue={"全部"}
                                        value={STATUTS_MAP["type_"+this.state.tsStatus].name}
                                        onChange={(tsStatus)=>{
                                            this.setState({tsStatus});
                                            this.loadData({
                                                ...this.state,tsStatus,start:1,size:10
                                            })
                                        }}
                                    >
                                        {
                                            [0,6,5,2,1,4,7,8,3].map(item=>{
                                                return <Option key={STATUTS_MAP["type_"+item].value} value={STATUTS_MAP["type_"+item].value}>
                                                    <span className={"status_item"}>{STATUTS_MAP["type_"+item].name}</span>
                                                </Option>
                                            })
                                        }
                                    </Select>
                                </div>
                                <div className={'form_item_right'}>
                                    <Button onClick={()=>{
                                        this.setState({
                                            ...this.defaultState
                                        });
                                        this.loadData(this.defaultState);
                                    }} type="primary" style={{backgroundColor:newSecondSelectColor,color: '#fefeff',borderColor:'#b2bad1'}}>
                                        重置筛选
                                    </Button></div>
                                <div className={'form_item_right'}>
                                    <span className={"new_activity_text"}>提交时间</span>
                                    <RangePicker
                                        value={[this.state.tsStartDate?moment(this.state.tsStartDate):undefined,
                                            this.state.tsEndDate?moment(this.state.tsEndDate):undefined]}
                                        onChange={dates=>{
                                            if(dates[0] && dates[1]){
                                                let tsStartDate = dates[0].hours(0).minutes(0).seconds(0).toDate().getTime();
                                                let tsEndDate = dates[1].hours(23).minutes(59).seconds(59).toDate().getTime();
                                                this.setState({
                                                    tsStartDate,tsEndDate
                                                });
                                                this.loadData({
                                                    ...this.state,tsStartDate,tsEndDate
                                                });
                                            }else{
                                                this.setState({
                                                    tsStartDate:undefined,tsEndDate:undefined
                                                });
                                                this.loadData({
                                                    ...this.state,tsStartDate:undefined,tsEndDate:undefined
                                                });
                                            }
                                        }}
                                    />
                                </div>
                                <div className={'form_item_right'}>
                                    <Search
                                        placeholder="输入搜索内容"
                                        onSearch={queryStr => {
                                            this.setState({queryStr});
                                            this.state.start=1;
                                            this.loadData({
                                                ...this.state, queryStr
                                            });
                                        }}
                                        onChange={(e)=>this.setState({queryStr:e.target.value})}
                                        value={this.state.queryStr}
                                        style={{ width: 200}}
                                    />
                                </div>
                            </Form>
                        </div>
                        <div style={{marginTop:'10px'}}><Button type="dashed" style={{width:'100%',height:'50px'}} onClick={()=>this.showAddModal()}>
                            <img src={'images/newsactivity/news_activity_add.png'} />
                            <span style={{marginLeft:'10px',color:'#a4adc8',fontSize:'16px',fontFamily: 'MicrosoftYaHei'}}>添加</span>
                        </Button>
                            <style>
                                {`
            .ant-btn-dashedhover{
            border-color:${newSecondSelectColor} !important;
            }
                             `}</style>
                        </div>
                    </div>}
                <div className={"newactivity_table"} >
                    <Scrollbars
                        autoHeight
                        autoHeightMax={(()=>{
                            let clientHeight = parseInt(window.document.body.clientHeight);
                            return clientHeight - HEADER_HEIGHT - 240;
                        })()}
                    >
                        <div style={{background:"#fff"}}> 
                        <Table  showHeader={false} columns={this.columns} dataSource={this.state.data}
                                rowKey={record=>record.id}
                                pagination={false}
                         />
                        </div>
                       
                    </Scrollbars>
                    <div style={{marginTop:10}}>
                    <Pagination 
                    style={{ textAlign: 'right'}}
                    total={this.state.count}
                    current={this.state.start}
                    onChange={(page, pageSize) => { this.loadData({...this.state, start:page, size: pageSize}); }}
                    />
                    </div>
                </div>
                <Modal
                    title={this.state.topicSelection.id ? '编辑选题' : '新增选题'}
                    width={800}
                    visible={this.state.topicSelectionListFormModalVisible}
                    maskClosable={false}
                    onCancel={()=>{this.setState({topicSelectionListFormModalVisible:false})}}
                    footer={ this.state.step === 1 ? <div>
                        <Button type={"primary"} onClick={()=>{this.save(2);//提交
                        }}>提交选题</Button>
                         <style>
                        {`
            .ant-btn-primary{
                margin-right: 10px;
            background-color:${newSecondSelectColor} !important;
            border-color:${newSecondSelectColor} !important;
            }
                             `}</style>
                        <Button onClick={()=>{this.save(1);//草稿
                        }}>保存</Button>
                        <Button onClick={()=>{this.setState({topicSelectionListFormModalVisible:false})
                        }}>关闭</Button>
                    </div> : 
                    <div>
                    <Button type={"primary"} onClick={()=>{ this.showAddModal()//提交
                    }}>继续创建</Button>
                      <style>
                        {`
            .ant-btn-primary{
               
            background-color:${newSecondSelectColor} !important;
            border-color:${newSecondSelectColor} !important;
            }
                             `}</style>
                    <Button style={{marginLeft:10}} onClick={()=>{this.setState({topicSelectionListFormModalVisible:false})
                    }}>关闭</Button>
                </div>}
                >
                    {
                        this.state.step === 1 ? 
                        <TopicSelectionListFormModal
                        data={this.state.topicSelection}
                        key={this.state.topicSelectionListFormKey}
                        pmsUser={this.pmsUser}
                        currentUser={this.props.currentUser}
                        sysConfig = {this.props.sysConfig}
                        tsCreateByChange={(tsCreateBy)=>{
                            this.setState(prevState=>{
                                prevState.topicSelection.tsCreateBy = tsCreateBy;
                                return prevState;
                            });
                        }}
                        wrappedComponentRef={(inst)=>this.topicSelectionListForm=inst}/> : 
                        <NewsActivityComplete type="选题管理" topicSelectionData={{topicSelection: this.state.topicSelection}}/>
                    }
                </Modal>
                <Modal
                    width={600}
                    title={"指派写作"}
                    visible={this.state.assignModalVisible}
                    maskClosable={false}
                    onCancel={()=>{this.setState({assignModalVisible:false})}}
                    footer={<div>
                        <Button onClick={()=>this.setState({assignModalVisible:false})}>取消</Button>
                        <Button type={"primary"} onClick={()=>{
                            if(!this.selectAssignAccount || this.selectAssignAccount.length === 0){
                                message.error("请至少指派一位用户");
                                return ;
                            }
                            if(this.state.topicSelection.id){
                                window.loading.show();
                                assignedWriting(this.state.topicSelection.id, this.selectAssignAccount, this.tsRemark).then(res=>{
                                    window.loading.hide();
                                    this.setState({
                                        assignModalVisible:false
                                    });
                                    if(this.state.viewTopicSelectionVisible){
                                        this.viewTopicSelection(this.state.topicSelection);
                                    }
                                    this.loadData(this.state);//重新加载列表
                                });
                            }
                        }}>确定</Button>
                    </div>}
                >
                    <Scrollbars
                        autoHeight
                        autoHeightMax={500}
                    >
                        <table border={0} cellPadding={0} cellSpacing={0} width={"100%"}>
                            <tbody>
                                <tr>
                                    <td width={70} align={"left"}>指派给：</td>
                                    <td><EditableTagGroup
                                        tags={(()=>{
                                            let names = [];
                                            let pmsUser = this.pmsUser;
                                            let tsAppointee = this.selectAssignAccount;
                                            for(let j = 0 ; pmsUser && j < pmsUser.length; j++){
                                                let user = pmsUser[j];
                                                for(let k = 0; tsAppointee && k < tsAppointee.length; k++){
                                                    if(tsAppointee[k] === user.account){
                                                        let isAdd = true;//已经添加过的就不添加了
                                                        for(let i = 0 ; i < names.length; i++){
                                                            if(names[i] === user.name){
                                                                isAdd = false;
                                                                break;
                                                            }
                                                        }
                                                        if(isAdd){
                                                            names.push(user.name);
                                                        }
                                                        break;
                                                    }
                                                }
                                            }
                                            return names;
                                        })()}
                                        onChange={tags=>this.tagGroupChange(tags)}
                                        inputType={"autoComplete"}
                                        newTagText={"添加"}
                                        autoCompleteData={(()=>{
                                            let userNames = [];
                                            this.pmsUser && this.pmsUser.map(user=>{
                                                userNames.push(user.name);
                                            });
                                            return userNames;
                                        })()}
                                        autoCompleteFilterOption={(inputValue, option) =>
                                            option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
                                    /></td>
                                </tr>
                                <tr>
                                    <td align={"left"} valign={"top"} style={{paddingTop:"10px"}}>备注信息：</td>
                                    <td style={{padding:"10px"}}>
                                        <TextArea
                                            rows={5}
                                            value={this.tsRemark}
                                            onChange={e=>{
                                                this.tsRemark = e.target.value;
                                                this.setState({});
                                            }}/></td>
                                </tr>
                            </tbody>
                        </table>
                    </Scrollbars>
                </Modal>
                <TabModal visible={this.state.viewTopicSelectionVisible}
                          onCancel={()=>{
                              this.setState({
                                  viewTopicSelectionVisible: false
                              })
                          }}
                          width={1100}
                          activeIndex={this.viewTopicSelectionActiveIndex}
                          tabs={(()=>{
                              let res = [{
                                  title:"基本信息",
                                  footer:<div className={"ant-modal-footer"}>
                                      {(()=>{
                                          let btns = this.getBtns(this.props.currentUser, haveEditAuthRoleCode, this.state.topicSelection);
                                          return btns.map(({name, click, type},index)=>{
                                              if(parseInt(this.state.topicSelection.tsStatus) === 8){
                                                  if(name === "查看稿件"){
                                                      return;
                                                  }
                                              }
                                              if(type && (type.name === "popover")){
                                                  return <Popover key={index} placement="top" title={undefined} content={type.content} trigger="click">
                                                      <Button>{name}</Button>
                                                  </Popover>
                                              }else{
                                                  return <Button key={index} onClick={click}>{name}</Button>
                                              }
                                          });
                                      })()}
                                  </div>
                              }];
                              console.log("this.state.topicSelection:    ", JSON.parse(JSON.stringify(this.state.topicSelection)));
                              (parseInt(this.state.topicSelection.tsStatus) === 8) && res.push({title:"稿件列表",footer:null});
                              return res;
                          })()}
                          tabPanels={(()=>{
                              let res = [<TopicSelectionBaseInfo
                                  data={this.state.topicSelection}/>];
                              (parseInt(this.state.topicSelection.tsStatus) === 8) && res.push(<Manuscript
                                  key={uuid()}
                                  listUrl={`/cm-sites-${applicationName()}/originalStory/queryStoryByTopicId?topicSelectionId=${this.state.topicSelection.id}`}
                                  id={this.state.topicSelection.id}/>);
                              return res;
                          })()} />
            </div>
        );
    }

}

class TopicSelectionListForm extends Component{

    state={
        data:this.props.data,
        fileList:[],
        pmsUser:this.props.pmsUser
    };

    componentWillMount() {
        this.showFileList(this.props.data.tsFileIds);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            data:nextProps.data,
            pmsUser:nextProps.pmsUser
        });
        if(nextProps.data.tsFileIds !== this.props.data.tsFileIds){
            this.showFileList(nextProps.data.tsFileIds);
        }
    }

    showFileList = (attachmentResourceIds)=>{
        if(attachmentResourceIds && attachmentResourceIds.length > 0){
            getAttachmentFiles(attachmentResourceIds).then(res=>{
                let newFileList = [];
                res && res.map(item=>{
                    newFileList.push({
                        url:"images/file.png",
                        uid:item.id,
                        resourceId:item.id,
                        path:item.url,
                        status:"done",
                        name:item.name,
                        icon:<img src={"images/file.png"} width={70} height={90} />
                    })
                });
                this.setState({ fileList:newFileList });
            })
        }
    };

    handleChangeFileList = ({ file, fileList }) => {
        if(file.status === "done") {
            this.checkStatus(file.response.storageFile.md5, (stateStr)=>{
                let newFileList = fileList.map(item=>{
                    if(item.uid === file.uid){
                        item.url = "";
                        item.path = file.response.url;
                        item.ingStatus = stateStr;
                    }
                    return item;
                });
                this.setState({ fileList:newFileList });
            },(response)=>{
                file.response = response;
                this.saveFile(file).then(res=>{
                    let newFileList = fileList.map(item=>{
                        if(item.uid === file.uid){
                            item.url = "images/file.png";
                            item.path = file.response.url;
                            item.resourceId = res.resourceId;
                            item.icon = <img src={"images/file.png"} width={70} height={90} />;
                        }
                        return item;
                    });
                    this.setState({ fileList:newFileList });
                }).catch(err=>{
                    message.error("附件存放媒资库中出错");
                });
            });
        }
        this.setState({ fileList });
    };

    saveFile(file){
        let result = file.response;
        let url;
        let fileTemp = {};
        let params = {};
        let files=[];
        fileTemp.dataSource = 4;//这里需要修改 需要增加选题的这样的一个来源
        fileTemp.name = result.storageFile.name;
        fileTemp.ext = result.storageFile.suffix;
        fileTemp.path = result.url;
        fileTemp.size = result.storageFile.size ? result.storageFile.size : file.size;
        fileTemp.storyId = 0;
        fileTemp.md5 = result.storageFile.md5;
        fileTemp.publish=0;
        params.dataSource = 4;
        if(PIC_TYPE.indexOf(result.storageFile.suffix) !== -1){
            url = "/cm-sites-pms/v3/zyk/savePicture";
            fileTemp.imageHeight = result.storageFile.height;
            fileTemp.imageWidth = result.storageFile.width;
            files.push(fileTemp);
            params.pictures=files;
        }else if(VIDEO_TYPE.indexOf(result.storageFile.suffix) !== -1){
            url = "/cm-sites-pms/v3/zyk/saveVideo";
            fileTemp.frameHeight = result.storageFile.height;
            fileTemp.frameWidth = result.storageFile.width;
            fileTemp.allTime = result.storageFile.duration;
            files.push(fileTemp);
            params.videos=files;
        }else if(AUDIO_TYPE.indexOf(result.storageFile.suffix) !== -1){
            url = "/cm-sites-pms/v3/zyk/saveAudio";
            fileTemp.allTime = result.storageFile.duration;
            files.push(fileTemp);
            params.audios=files;
        }else if(ATTCHMENT_TYPE.indexOf(result.storageFile.suffix) !== -1){
            url = "/cm-sites-pms/v3/zyk/saveOtherFile";
            files.push(fileTemp);
            params.otherFiles=files;
        }
        return new Promise((resolve, reject) => {
            window.$.ajax({
                type: "post",
                url: url,
                cache: false,
                // async: false,
                data: JSON.stringify(params),
                dataType: "json",
                contentType: 'application/json;charset=UTF-8',
                success: function (res) {
                    let data;
                    if(res.data){
                        data=JSON.parse(res.data);
                        resolve(data&&data.length&&data[0]);
                    }
                },error: function (err) {
                    console.log("err:    ", err);
                    reject(err);
                }
            });
        });
    }

    handleRemove = async file => {
        this.setState(prevState => {
            let fileList = prevState.fileList.filter(item=>{
                return item.uid !== file.uid
            });
            return {
                fileList
            }
        });
    };

    //检查上传之后的状态，视频有的时候需要查看是否合并完成了
    checkStatus(md5, ingCallBack, overCallBack){
        setTimeout(()=>{
            checkFileStatus(md5).then(res=>{
                if(res.state !== "mergeComplete"){
                    this.checkStatus(md5, ingCallBack, overCallBack);
                    ingCallBack(res.stateStr);
                }else{
                    overCallBack(res);
                }
            }).catch(()=>{
                overCallBack({});
            });
        }, 100);//每隔一秒钟进行检查一次
    }

    tagGroupChange(tags){
        this.setState(prevState=>{
            let tsCreateBy = [];
            for(let i = 0 ; tags && i < tags.length; i++){
                let tagName = tags[i];
                for(let j = 0 ; this.state.pmsUser && j < this.state.pmsUser.length; j++){
                    let user = this.state.pmsUser[j];
                    if(user.name === tagName){
                        let isAdd = true;//已经添加过的账号就不添加了
                        for(let k = 0; tsCreateBy && k < tsCreateBy.length; k++){
                            if(tsCreateBy[k] === user.account){
                                isAdd = false;
                                break;
                            }
                        }
                        if(isAdd){
                            tsCreateBy.push(user.account);
                        }
                        break;
                    }
                }
            }
            this.props.tsCreateByChange(tsCreateBy);
            prevState.data.tsCreateBy = tsCreateBy;
            return prevState;
        });
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        return <div className={"newActivityBaseInfo_container"}>
            <Scrollbars
                autoHeight
                autoHeightMax={600}
                id="newActivityBaseInfo_container_scroll"
            >
                <table className={"form_table"} width={"100%"}>
                    <tbody>
                    <tr><td className={"form_name_title"}>选题名称<span style={{color:'red'}}>*</span></td>
                        <td className={"form_name_title"}>涉及单位</td></tr>
                    <tr><td className={"form_name_value"}>
                        {getFieldDecorator('tsName', {
                            rules: [{ required: true, message: '请输入选题名称' }],
                            initialValue: this.props.data.tsName
                        })(<Input maxLength={200} />)}
                    </td>
                    
                    <td className={"form_name_value"} >
                        {getFieldDecorator('tsCompany', {
                            initialValue: this.props.data.tsCompany
                        })( <AutoComplete
                            style={{ width: "100%" }}
                            dataSource={(()=>{
                                let sponsor = this.props.sysConfig && this.props.sysConfig.getValueByKey("new.activity.sponsor", "“清华辅导员”微信公众号,《北京日报》,《光明日报》,《中国高等教育》,《中国纪检监察报》,《中国教育报》,《中国青年报》,21世纪经济客户端,CCTV,CCTV-1 新闻联播,CCTV-13,iCenter,TMS协会,保密办,保卫部,北京青年报,北京清华长庚医院,北京日报,北京日报客户端,北京晚报,北京信息科学与技术国家研究中心,本招办,博士生讲师团,材料学院,财务处,参考消息,产业发展与环境治理研究中心,昌平办,车辆学院,出土文献中心,大理日报,大数据研究中心,档案馆,党办,党办校办,党委保卫部（保卫处）,党委统战部,党委武装部（国防教育与人才培养办公室）,党委宣传部（新闻中心）,党委学生部（学生处）,党委巡察工作办公室,党委组织部（含机关党委）,低碳能源实验室,地学系,第一附属医院,电机系,电子工程系,电子系,对口支援办,俄罗斯研究院,发展规划处,法学院,法制日报,法治与法务办公室,高技术实验室,高校思政网,高研院,工会,工物系,工业工程系,公共卫生与健康学院,公管学院,光明日报,光明日报客户端,光明网,国际处,国际合作与交流处（港澳台办）,国内合作办,航发院,航天航空学院,航院,核研院,后勤党委,华信医院（第一附属医院）,化工系,化学系,环境学院,会计核算中心,机关党委,机械系,基础工业训练中心,基建处,基金会,计算机系,纪委,纪委办公室,纪委办监察室,技术转移研究院,继教学院,继续教育学院,检察日报,建筑学院,建筑学院（含建环）,交叉信息研究院,交叉信息院,教师发展中心,教务处,教研院,教育基金会,教育研究院,接待服务中心,街道办事处,洁华幼儿园,解放军报,金融学院,京报网,经管学院,经济参考网,经济日报,经资办,精神文明报,精仪系,科技日报,科技日报微信号,科学博物馆（筹）,科学网,科研院,拉美中心,离退休处,离退休工作部（离退休处）,理论网,临床医学院,绿办,马克思主义学院,美术学院,美院,南方都市报,脑与智能实验室,能动系,澎湃新闻,澎湃新闻客户端,澎湃新闻网,汽车系,清华PPP研究中心,清华-伯克利深圳学院,清华大学本科教学,清华大学出版社,清华大学公众号,清华大学教育基金会公众号,清华大学美术学院,清华大学微信公众号,清华大学医院,清华大学中国新型城镇化研究院,清华附小,清华附中,清华校友总会,清华校友总会（同校友办）,清华新闻网,清华研读间,清华长庚医院,清小暑微信公众号,全球创新学院,人民论坛网,人民日报,人民日报海外版,人民网,人民政协报,人事处（教师工作部）,人文清华,人文清华讲坛,人文学院,柔电中心,软件学院,三亚中心,山东卫视,社科学院,深耕计划,深圳国际研究生院,深圳新闻网,深圳研究生院,审计室,生命学院,生态文明清华园公众号,实验室管理处,世界大学气候变化联盟秘书处,书院,书院管理中心,数学科学中心,数学系,水利系,苏世民书院,体育部,体育代表队,天文系,同方威视,图书馆,土木系,土木系（含建管）,土水学院,团委,外文系,网络研究院,微纳电子系,未来实验室,文化建设办公室（文物保护办公室）,文化素质教育基地,文科处,文孙宇,无障碍发展研究院,武装部,物理系,西昌都市报,校办,校机关党委,校史馆,校史研究室（党史研究室、校史馆）,校团委,校学生会,校研会,校研究生会,校研团委,校友会,校友总会,校园专项办,新华每日电讯,新华社,新华社客户端,新华网,新京报,新京报网,新闻联播,新闻学院,新闻中心,新雅书院,信息化工作办公室,信息化技术中心,信息科学与技术国家研究中心,修缮校园管理中心,学科办,学生部,学生处,学生对外交流协会,学生会,学生科协,学生全球胜任力发展指导中心,学生社区管理服务中心,学生社区中心,学生学习与发展指导中心,学生职业发展指导中心,学术委员会,学堂在线,学位办,巡察办,训练中心,研工部,研究生会,研究生团委,研究生院,研团委,央广网,央视网,央视新闻,央视新闻客户端,药学院,一附院,医工交叉研究院,医学院,艺教中心,艺术博物馆,饮食中心,语言中心,玉泉医院（第二附属医院）,长庚医院,长江日报,招办,招生办公室,政策研究室,职业发展指导中心,职业发展中心,智库中心,中非领导力发展中心,中国电子报,中国高等教育,中国华能微信号,中国环境报,中国纪检监察报,中国教育报,中国教育新闻网,中国教育在线,中国经济时报,中国科技网,中国科学报,中国科学技术协会,中国汽车报,中国青年报,中国青年报客户端,中国日报网,中国社会科学网,中国新闻网,中国新型城镇化研究院,中华人民共和国应急管理部微信号,中央纪委国家监委网,中央纪委国家监委网站,终身教育处,资产管理处,自动化系,总会计师办公室,总务长办公室（同后勤管理处）,组织部,最高人民法院微信号");
                                return sponsor?sponsor.split(","):""
                            })()}
                           // placeholder="请输入涉及单位"
                            filterOption={(inputValue, option) =>
                                option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                            }
                        />)}
                    </td>
                    </tr>
                    <tr>
                        <td className={"form_name_title"}>联系人</td>
                        <td className={"form_name_title"}>联系方式</td></tr>
                    <tr><td className={"form_name_value"}>
                        {getFieldDecorator('tsContactsName', {
                            initialValue: this.props.data.tsContactsName
                        })(<Input  maxLength={20} />)}
                    </td><td className={"form_name_value"}>
                        {getFieldDecorator('tsContactsPhone', {
                            initialValue: this.props.data.tsContactsPhone
                        })(<Input maxLength={50} />)}
                    </td></tr>
                    </tbody>
                </table>
                <div className={"form_activity_content"}>
                    <span className={'title'}>创建人</span>
                    <EditableTagGroup
                        tags={(()=>{
                            let names = [];
                            for(let k = 0; this.state.data.tsCreateBy && k < this.state.data.tsCreateBy.length; k++){
                                for(let j = 0 ; this.state.pmsUser && j < this.state.pmsUser.length; j++){
                                    let user = this.state.pmsUser[j];
                                    if(this.state.data.tsCreateBy[k] === user.account){
                                        let isAdd = true;//已经添加过的就不添加了
                                        for(let i = 0 ; i < names.length; i++){
                                            if(names[i] === user.name){
                                                isAdd = false;
                                                break;
                                            }
                                        }
                                        if(isAdd){
                                            names.push(user.name);
                                        }
                                        break;
                                    }
                                }
                            }
                            return names;
                        })()}
                        onChange={tags=>this.tagGroupChange(tags)}
                        inputType={"autoComplete"}
                        newTagText={"添加"}
                        firstTagClosable={false}
                        autoCompleteData={(()=>{
                            let userNames = [];
                            this.state.pmsUser && this.state.pmsUser.map(user=>{
                                userNames.push(user.name);
                            });
                            return userNames;
                        })()}
                        autoCompleteFilterOption={(inputValue, option) =>
                            option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
                    />
                    <span className={'title'}>选题内容</span>
                    {getFieldDecorator('tsContent', {
                        initialValue: this.props.data.tsContent
                    })(<TextArea rows={4}/>)}
                    <span className={'title'}>附件</span>
                    <UploadWall
                        accept={"."+FILE_TYPE.join(",.")}
                        multiple={true}
                        action="/cm-sites-pms/index/uploadFile"
                        listType="picture-card"
                        fileList={this.state.fileList}
                        customRequest={new ChunkUpload({
                            checkFileURL:"/cm-sites-"+applicationName()+"/index/checkFile",
                            checkChunkURL:"/cm-sites-"+applicationName()+"/index/checkChunk",
                            uploadChunkURL:"/cm-sites-"+applicationName()+"/index/uploadChunks",
                            chunkUploadOverURL:"/cm-sites-"+applicationName()+"/index/chunkUploadOver",
                            mergeChunksURL:"/cm-sites-"+applicationName()+"/index/mergeChunks"
                        }).start}
                        icons={["download", "delete"]}
                        uploadBtnName={"上传附件"}
                        onChange={this.handleChangeFileList}
                        onRemove={this.handleRemove}
                        listType={"list"}
                        onDownload={(file)=>{
                            if(file.path.indexOf("?") === -1){
                                window.location.href = file.path + "?download=1";
                            }else{
                                window.location.href = file.path + "&download=1";
                            }
                        }}
                    />
                </div>
            </Scrollbars>
        </div>
    }
}
TopicSelectionListForm.defaultProps = {
    data:{},
    pmsUser:[],
    tsCreateByChange:()=>{}
};

export let TopicSelectionListFormModal = Form.create()(TopicSelectionListForm);


function mapStateToProps(state){
    return {
        currentUser: state.systemReducer.currentUser,
        sysConfig : state.systemReducer.config,
        navigateData: state.systemReducer.navigateData,
        navigateStatus: state.systemReducer.navigateStatus,
    }
}
function mapStateToMethod(dispatch) {
    return {
        shrinNavigateStauts: function () {
            return dispatch(shrinNavigateStauts());
        },
        updateNavigateLevel2Data: function (title, data) {
            return dispatch(updateNavigateLevel2Data(title, data));
        },
        updataNavigateData:function (data) {
            return dispatch(updataNavigateData(data))
        }
    }
}

export default      Form.create()(connect(mapStateToProps,mapStateToMethod)(TopicSelectionList));